(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/balance.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/balance.js');
"use strict";


const Balance = _ref => {
  let _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Saldo' : _ref$label,
    value = _ref.value;
  const animateNumbers = svs.tur.ReactPayfooter.utils.animateNumbers;
  const balanceRef = React.useRef();
  const currentBalance = React.useRef(0);
  React.useEffect(() => {
    if (balanceRef.current) {
      animateNumbers({
        element: balanceRef.current,
        from: currentBalance.current,
        to: value
      });
      currentBalance.current = value;
    }
  }, [value]);
  if (isNaN(parseFloat(value))) return null;
  return React.createElement("div", {
    className: "payfooter-text-balance"
  }, React.createElement("div", {
    className: "payfooter-numbers",
    ref: balanceRef
  }, "".concat(label, ": ").concat(svs.utils.format.Currency(value), " kr")));
};
svs.tur.ReactPayfooter.Balance = Balance;

 })(window);